import {
  Component,
  OnInit,
  Inject,
  Renderer2,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data/data.service';
import { ApiService } from 'src/app/services/api/api.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { UpdateService } from 'src/app/services/update/update.service';
import { NgbOffcanvas, NgbOffcanvasConfig } from '@ng-bootstrap/ng-bootstrap';
import { DocumentationComponent } from '../documentation/documentation.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    public dataService: DataService,
    private api: ApiService,
    private utility: UtilityService,
    private updateService: UpdateService,
    config: NgbOffcanvasConfig,
    private offcanvasService: NgbOffcanvas
  ) {
    // customize default values of offcanvas used by this component tree
    config.position = 'end';
    config.keyboard = true;
    config.scroll = false;
    config.animation = true;
    config.backdrop = true;
  }

  @Output() loader = new EventEmitter<boolean>();

  outlets: any;

  isLoading = true;

  selectedOutlet: any;

  initials: any;
  isDarkMode: boolean = false;

  updateAvailable = false;

  ngOnInit(): void {
    this.updateService.checkForUpdates();
    // update the data
    this.updateService.latestVersionSubject.subscribe(
      (latestVersion: boolean) => {
        this.updateAvailable = latestVersion;
        if (this.updateAvailable) {
          this.hardRefresh();
        }
      }
    );
    const darkMode = localStorage.getItem('darkMode');
    if (darkMode) {
      this.isDarkMode = JSON.parse(darkMode);
      if (this.isDarkMode) {
        document.body.classList.remove('light-theme');
      } else {
        document.body.classList.add('light-theme');
      }
    } else {
      document.body.classList.add('light-theme');
    }
    // this.sendValueToBase(this.isLoading);
    // get outlets
    this.api.getOutlets().subscribe(
      (res: any) => {
        if (res && res.message) {
          this.outlets = res.message;
        }
      },
      (err: any) => {
        console.log(err);
        this.utility.alertError(
          err.error.error ? err.error.error : 'Unable to fetch outlets'
        );
      },
      () => {
        this.api.checkVersion().subscribe(
          (res: any) => {
            if (res && res.version) {
              console.log(res);
              if (this.dataService.version === res.version) {
                this.updateService.latestVersionAvailable = false;
              } else {
                this.updateService.latestVersionAvailable = true;
              }
            }
          },
          (err: any) => {
            console.log(err);
          },
          () => {
            // get unique outlets from dataService.userPermissions
            let uniqueOutlets = [
              ...new Set(
                this.dataService.userPermissions.map(
                  (perm: any) => perm.outlet_id
                )
              ),
            ];

            if (!this.dataService.userDetails.is_admin) {
              this.outlets = this.outlets.filter((outlet: any) =>
                uniqueOutlets.includes(outlet.id)
              );
            } else {
              this.outlets.push({
                id: 0,
                name: this.dataService.userDetails.business_name,
              });
            }
            if (
              localStorage.getItem('outletId') &&
              localStorage.getItem('outletId') == '0'
            ) {
              this.dataService.defaultPermissions = {
                view: 1,
                create: 1,
                update: 1,
                delete: 1,
                auto_approve: 1,
              };
            }

            this.dataService.outlets = this.outlets;
            //console.log(this.dataService.outlets);
            this.outletOnStartup();

            // this.selectedOutlet = this.outlets[0].id;
            this.initials = this.getInitials();

            this.isLoading = false;
            this.sendValueToBase(this.isLoading);
          }
        );
        // if (
        //   localStorage.getItem('outletId') &&
        //   localStorage.getItem('outletId') == '0'
        // ) {
        //   this.dataService.defaultPermissions = {
        //     view: 1,
        //     create: 1,
        //     update: 1,
        //     delete: 1,
        //     auto_approve: 1,
        //   };
        // }

        // this.dataService.outlets = this.outlets;
        // //console.log(this.dataService.outlets);
        // this.initials = this.getInitials();
        // this.outletOnStartup();

        // // this.selectedOutlet = this.outlets[0].id;

        // this.isLoading = false;
        // this.sendValueToBase(this.isLoading);
      }
    );
  }

  updateApplication() {
    this.updateService.hardRefresh();
  }

  hardRefresh() {
    // hard refresh after a min if the person is not on recent version
    if (this.updateService.latestVersionAvailable) {
      setTimeout(this.updateService.hardRefresh, 60000);
    }
  }

  sendValueToBase(value: boolean) {
    this.loader.emit(value);
  }

  // setSelectedOutletInDataService() {
  //   this.dataService.selectedOutlet = this.selectedOutlet;
  // }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    localStorage.clear();
    this.dataService.clearData();

    // localStorage.removeItem('token');

    if (!localStorage.getItem('isLoggedin')) {
      this.router.navigate(['/auth/login']);
      // refresh page
      location.reload();
    }
  }
  outletOnChange(e: any) {
    if (e == 0) {
      this.selectedOutlet =
        this.dataService.outlets[this.dataService.outlets.length - 1].id;
    }
    this.dataService.selectedOutlet = e;
    localStorage.setItem('outletId', e.toString()); // Convert 'e' to string before storing
    this.restartApplication();
  }

  outletOnStartup() {
    let outletInStorage: any = localStorage.getItem('outletId');
    outletInStorage = parseInt(outletInStorage, 10); // Convert to integer

    let outlet;
    if (outletInStorage || outletInStorage == 0) {
      outlet = this.outlets.find((ele: any) => {
        return outletInStorage === ele.id;
      });
      if (outletInStorage == 0) {
        this.dataService.defaultPermissions = {
          view: 1,
          create: 1,
          update: 1,
          delete: 1,
          auto_approve: 1,
        };
      }
      if (outlet) {
        this.dataService.selectedOutlet = outletInStorage;
        this.selectedOutlet = outletInStorage;
      } else {
        this.selectedOutlet = this.outlets[0].id;
      }
    } else if (outletInStorage === 0) {
      this.dataService.selectedOutlet = 0;
      // this.dataService.selectedOutlet =
      //   this.dataService.outlets[this.dataService.outlets.length - 1].id;
      // this.selectedOutlet =
      //   this.dataService.outlets[this.dataService.outlets.length - 1].id;
    } else {
      const preDefineOutletId =
        this.dataService.userPermissions[0]?.outlet_id || 0;
      this.dataService.selectedOutlet = preDefineOutletId;
      this.selectedOutlet = preDefineOutletId;
      localStorage.setItem('outletId', preDefineOutletId.toString()); // Convert to string before storing
    }
  }

  restartApplication() {
    // //Get the current route
    // const currentRoute = this.router.routerState.snapshot.url;

    // // Navigate back to the initial route
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigateByUrl(currentRoute);
    // });
    location.reload();
  }

  getInitials() {
    let name = this.dataService.userDetails.name;
    if (name) {
      let initials = name.split(' ');
      if (initials.length > 1) {
        return initials[0].charAt(0) + initials[initials.length - 1].charAt(0);
      } else {
        return initials[0].charAt(0);
      }
    }
    return null;
  }

  toggleTheme(event: any) {
    this.isDarkMode = event.target.checked;
    localStorage.setItem('darkMode', JSON.stringify(this.isDarkMode));
    if (this.isDarkMode) {
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
    }
  }

  navigate() {
    this.router.navigate(['/settings/profile']);
  }

  openDocumentation() {
    this.offcanvasService.open(DocumentationComponent);
  }
}
